{
    "AppMenu_AppsTitle": "Speisekarte",
    "AppMenu_Apps_Reporting": "Analysen",
    "AppMenu_Apps_FastProvisioning": "Schnelle Bereitstellung",
    "AppMenu_Apps_Administration": "Verwaltung",
    "AppMenu_Apps_StatusAndTools": "Status und Tools",
    "AppMenu_FavouritesTitle": "Favoriten",
    "NAME": "AppMenu"
}